import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Checkbox extends Component {
  static propTypes = {
    hasError: PropTypes.bool,
    id: PropTypes.string.isRequired,
    indeterminate: PropTypes.bool,
    label: PropTypes.string.isRequired,
  };
  static defaultProps = {
    hasError: false,
    indeterminate: undefined,
  };

  componentDidMount() {
    // Apply the indeterminate attribute of the checkbox input
    this.selector.indeterminate = this.props.indeterminate;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.indeterminate !== this.props.indeterminate) {
      this.selector.indeterminate = this.props.indeterminate;
    }
  }

  render() {
    const { id, label, name, indeterminate, hasError, isChecked, unsureCheckbox, ...inputProps } = this.props;
    const checkboxClassname = `
      custom-checkbox
      ${(hasError) ? 'custom-checkbox--has-error' : ''}
      ${(unsureCheckbox) ? 'custom-checkbox--full-width' : ''}
    `;

    const inputClassname = `
      custom-checkbox__input
    `;

    const labelClassname = `
      custom-checkbox__label
    `;

    return (
      <div className={checkboxClassname}>
        <input
          type="checkbox"
          className={inputClassname}
          ref={el => (this.selector = el)}
          id={id}
          name={name}
          value={label}
          checked={(isChecked) ? true : false}
          {...inputProps}
        />
          <label className={labelClassname} htmlFor={id}>{label}</label>
      </div>
    );
  }
}

export default Checkbox
